import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plausible = defineConnector({
  identifier: "plausible",
  name: "Plausible",
  tagLine: "Privacy-friendly web analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://(?:plausible\\.io/.*|[^/]*\\.plausible\\.io/.*)",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Plausible API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Plausible](https://plausible.io/settings/api-keys), go to **Settings > API Keys** and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://plausible.io/api/v1/stats/aggregate?site_id=example.com&period=day&metrics=visitors",
  },
});
